export function CategoryCellRenderer(props) {
  try {
    if (props.data && props.value !== "") {
      const celldata = props.colDef?.options;
      const stat = celldata?.find((item) => {
        return (item?._id || item?.id) === props?.data[props?.colDef?.field];
      });
      if (stat) {
        return <span>{stat?.name}</span>;
      }
    } else {
      const groupval = props.value;
      const options = props.node?.rowGroupColumn?.colDef?.options;
      if (options && Array.isArray(options)) {
        return options.find((itt) => (itt._id || itt.id) === groupval)?.name;
      } else {
        return props.value;
      }
    }
  } catch (error) {
    console.log(error.message);
  }
}
